<template>
	<div>
		<div class="hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}</b-button>
			</div>
			<div class="pull-right">
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print" /> {{ $t('Печать') }}
				</b-button>
			</div>
		</div>
		<b-card style="width: 100%">
			<b-overlay :show="loading" rounded opacity="0.7">
				<b-row>
					<b-col cols="3">
						<div style="font-size: 12px"><b>DutyFree International</b></div>
					</b-col>
					<b-col cols="6" class="text-center">
						<h6><b>{{ $t("termOfItems") }}</b></h6>
					</b-col>
					<b-col />
				</b-row>
				<b-row>
					<b-col>
						<b style="font-size: 12px">{{ $t('pricing.department') }}: {{ data.fromDepartmentName }}</b>
					</b-col>
				</b-row>
				<b-row class="mt-2 mb-2">
					<b-col>
						<table class="b-table table-hover table-bordered" style="font-size: 11px; width: 100%">
							<thead>
								<tr>
									<th class="text-center" style="font-size: 10px">№</th>
									<th class="text-center" style="font-size: 10px">{{ 'Продукт' }}</th>
									<th class="text-center" style="font-size: 10px">{{ 'Срок годность' }}</th>
									<th class="text-center" style="font-size: 10px">{{ 'Новый срок годность' }}</th>
									<th class="text-center" style="font-size: 10px">{{ 'Остаток' }}</th>
									<th class="text-center" style="font-size: 10px">{{ 'Цена' }}</th>
								</tr>
							</thead>
							<tbody style="padding: 0; margin: 0">
								<tr v-for="(item, index) in data.whItems" :key="`items-${index}`"
									style="padding: 0; margin: 0">
									<td class="text-center pt-1" style="font-size: 10px">{{ index + 1 }}</td>
									<td class="pt-1" style="font-size: 10px"><b>{{ item.barcode }} </b> {{ item.itemName
										}}</td>
									<td class="text-center pt-1" style="font-size: 10px">{{ item.termOfItem }}</td>
									<td class="text-center pt-1" style="font-size: 10px">{{ item.newTermOfItem }}</td>
									<td class="text-center pt-1" style="font-size: 10px">{{ item.count }}</td>
									<td class="text-center pt-1" style="font-size: 10px">{{ item.price ? item.price :
										item.priceUzs }}</td>
								</tr>
								<tr v-if="data.whItems.length > 0" />
								<tr v-else>
									<th colspan="6" class="text-center">
										<h4>{{ $t('empty') }}</h4>
									</th>
								</tr>
								<tr v-if="loading">
									<td colspan="6" class="text-center">
										<b-spinner small class="mr-2" /><strong>Loading...</strong>
									</td>
								</tr>
							</tbody>
						</table>
					</b-col>
				</b-row>
			</b-overlay>
		</b-card>
	</div>
</template>

<script>
import TermOfItemService from "./termOfItemService";
import { BOverlay } from 'bootstrapVue2';

export default {
	name: "view",
	components: { BOverlay },
	data() {
		return {
			loading: false,
			data: {}
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
	},
	created() {
		this.loading = true
		if (this.$route.params.action == 'out') {
			TermOfItemService.getById(this.$route.params.id).then(res => {
				this.data = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		} else {
			TermOfItemService.getByIdIn(this.$route.params.id).then(res => {
				this.data = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		}
	}
}
</script>

<style scoped>
@media print {
	.hidden-print {
		display: none;
	}
}
</style>
